export default __webpack_public_path__ + "static/assets/d4e1f4ca91191faf62c0ff35449b4af5.png";